import { Component, inject, OnInit } from '@angular/core';
import { SavedCartConfigService } from '../../services/saved-cart-config/saved-cart-config.service';

@Component({
    selector: 'lib-saved-cart-list',
    templateUrl: './saved-cart-list.component.html',
    styleUrls: ['./saved-cart-list.component.css'],
    standalone: false
})
export class SavedCartListComponent implements OnInit {
  public savedCartConfigService = inject(SavedCartConfigService);

  ngOnInit() {}
}
